import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

const AdminLogin = () => {
  const [email, setEmail] = useState("admin@briology.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (localStorage.getItem("briology_token")) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("briology_token", data.token);
      toast.success("Welcome back.");
      nav("/admin/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-white border border-black brutal-shadow p-8"
      >
        <div className="overline text-[10px] mb-1">Briology · Admin</div>
        <h1 className="font-serif-display text-4xl font-black mb-6">Sign in</h1>

        <label className="overline text-[10px] block mb-1">Email</label>
        <input
          data-testid="admin-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-transparent border-b-2 border-black focus:border-[#FF1493] outline-none py-2 mb-5 font-sans-display"
          required
        />

        <label className="overline text-[10px] block mb-1">Password</label>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-transparent border-b-2 border-black focus:border-[#FF1493] outline-none py-2 mb-8 font-sans-display"
          required
        />

        <button
          data-testid="admin-login-submit"
          disabled={loading}
          className="w-full bg-[#FF1493] text-white font-sans-display uppercase tracking-[0.18em] text-sm py-4 rounded-full hover:bg-black transition-colors duration-300 border border-black disabled:opacity-50"
        >
          {loading ? "Signing in…" : "Enter"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
